export default __webpack_public_path__ + "static/national-metric-desktop-132232603787c0a1b2a5f21dde7a8708.svg";